import { useSelector, useDispatch } from 'react-redux'
import { t } from '../../utils/i18n'
import InlineSvg from './../InlineSvg'
import {
  UndoButton,
  RedoButton,
  handleUndo,
  handleRedo
} from '../../components/Header'
import Popover from '../Popover'
import {
  presetsClicked,
  fullPaintClicked,
  shareClicked,
  inquiryClicked,
  bikeImageReload,
  undoClicked
} from '../../actions'
import { bikeConfigToQuery } from '../../utils/bike-config'
import { BACKEND_URL } from '../../utils/settings'

const SettingsPopover = () => {
  const dispatch = useDispatch()
  const { bikeConfig, undoCounter, undoed, fullHistory } = useSelector(
    (state) => state
  )

  const query = bikeConfigToQuery(bikeConfig)
  const downloadUrl = `${BACKEND_URL}/bike-image?download=1&${query}`

  const isCargo = bikeConfig.baseModelId.includes('cargo')
  return (
    <Popover
      width={window.innerWidth > 475 ? 360 : 320}
      alignTo=".velorbis-customizer-header-settings"
    >
      <div className="velorbis-customizer-popover-header">{t('settings')}</div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll velorbis-customizer-space-dist-v">
        <div className="velorbis-customizer-settings-group">
          <div
            className="velorbis-customizer-header-tool velorbis-customizer-header-inquiry velorbis-customizer-header-inquiry-mobile"
            onClick={() => dispatch(inquiryClicked())}
          >
            <div className="velorbis-customizer-header-tool-inner">
              <InlineSvg src="icons/mail" />
              <div>{t('inquiry_button')}</div>
            </div>
          </div>
          <div
            className="velorbis-customizer-header-tool velorbis-customizer-header-share velorbis-customizer-header-share-mobile"
            onClick={() => dispatch(shareClicked())}
          >
            <div className="velorbis-customizer-header-tool-inner">
              <InlineSvg src="icons/share" />
              <div>{t('share_button')}</div>
            </div>
          </div>
          <div
            className="velorbis-customizer-header-tool velorbis-customizer-header-presets"
            onClick={() => dispatch(presetsClicked())}
            title={t(isCargo ? 'select_angle' : 'presets_title')}
          >
            <div className="velorbis-customizer-header-tool-inner">
              <InlineSvg src="icons/grid" />
              <div>{t(isCargo ? 'select_angle' : 'presets_title')}</div>
            </div>
          </div>
          {!bikeConfig.baseModelId.includes('cargo') && (
            <div
              className="velorbis-customizer-header-tool velorbis-customizer-header-full-paint"
              onClick={() => dispatch(fullPaintClicked())}
              title={t('full_paint_title')}
            >
              <div className="velorbis-customizer-header-tool-inner">
                <InlineSvg src="icons/paintbrush" />
                <div>{t('full_paint_title')}</div>
              </div>
            </div>
          )}

          <UndoButton
            onClick={() =>
              handleUndo(
                (id) => dispatch(undoClicked(id)),
                () => dispatch(bikeImageReload()),
                fullHistory,
                undoCounter,
                undoed
              )
            }
          />
          <RedoButton
            onClick={() =>
              handleRedo(
                (id) => dispatch(undoClicked(id)),
                () => dispatch(bikeImageReload()),
                fullHistory,
                undoCounter,
                undoed
              )
            }
          />
          <a
            rel="noopener noreferrer"
            className="velorbis-customizer-header-tool"
            href={downloadUrl}
          >
            <div
              className="velorbis-customizer-header-tool-inner"
              title={t('download_jpg')}
            >
              <InlineSvg src="icons/jpg" />
              <div>{t('download_jpg')}</div>
            </div>
          </a>
          <a
            rel="noopener noreferrer"
            className="velorbis-customizer-header-tool"
            href={downloadUrl.replace('bike-image', 'bike-only-pdf')}
            title={t('download_pdf')}
          >
            <div className="velorbis-customizer-header-tool-inner">
              <InlineSvg src="icons/pdf" />
              <div>{t('download_pdf')}</div>
            </div>
          </a>
          <a
            rel="noopener noreferrer"
            className="velorbis-customizer-header-tool"
            href={downloadUrl.replace('bike-image', 'bike-pdf')}
            title={t('download_specifications')}
          >
            <div className="velorbis-customizer-header-tool-inner">
              <InlineSvg src="icons/spcfk" />
              <div>{t('download_specifications')}</div>
            </div>
          </a>
        </div>
      </div>
    </Popover>
  )
}

export default SettingsPopover
